// 締切は日本時間の「日付」で決まる。9/19 締切の宿題は 9/19 の 23:59:59.999 JST
// まで提出できる必要があるので、日付だけの入力はその日の終わりとして保存する。
// （日付の頭 = 00:00 UTC で保存すると、締切当日の朝 9 時に閉じてしまう）

const JST_OFFSET_MS = 9 * 60 * 60 * 1000
const DAY_MS = 24 * 60 * 60 * 1000

/** "2026-09-19"（JSTの暦日）→ その日の 23:59:59.999 JST を表す ISO 文字列 */
export function jstEndOfDayISO(dateStr: string): string {
  return new Date(Date.parse(`${dateStr}T00:00:00Z`) - JST_OFFSET_MS + DAY_MS - 1).toISOString()
}

/** その瞬間が JST でどの暦日にあたるか（"YYYY-MM-DD"） */
export function jstDateString(date: Date | string): string {
  const t = typeof date === 'string' ? new Date(date) : date
  return new Date(t.getTime() + JST_OFFSET_MS).toISOString().slice(0, 10)
}

/** 締切までの残り日数（JSTの暦日で数える。0 = 今日が締切、負 = 期限切れ） */
export function jstDaysUntil(deadline: string): number {
  const from = Date.parse(`${jstDateString(new Date())}T00:00:00Z`)
  const to = Date.parse(`${jstDateString(deadline)}T00:00:00Z`)
  return Math.round((to - from) / DAY_MS)
}
